import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';

import ListBox from '@components/ListBox/ListBox';
import * as actions from '@store/actions';

import Type from './Type/Type';
import FlightInfo from './FlightInfo/FlightInfo';
import Pricing from './Pricing/Pricing';
import Passenger from './Passenger/Passenger';
import TripSummary from './TripSummary/TripSummary';
import ThankYou from './ThankYou/ThankYou';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');

class Board extends Component {
  constructor(props) {
    super(props);

    let panelActive = 'type';

    this.state = {
      panelActive: panelActive,
      panels: [
        {
          id: 'type',
          title: 'Account Info',
          disabled: false
        },
        {
          id: 'flight-info',
          title: 'Flight Info',
          disabled: false
        },
        {
          id: 'pricing',
          title:
            props.data.profile_ContractVersion === 2
              ? 'Trip Information'
              : 'Pricing',
          disabled: true
        },
        {
          id: 'passenger',
          title: 'Passenger',
          content: 'Passenger',
          disabled: true
        },
        {
          id: 'trip-summary',
          title: 'Trip Summary',
          content: 'Trip Summary',
          disabled: true
        }
      ]
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // Typical usage (don't forget to compare props):
    if (this.props !== prevProps) {
      this.setState({
        panels: [
          {
            id: 'type',
            title: 'Account Info',
            disabled: false
          },
          {
            id: 'flight-info',
            title: 'Flight Info',
            disabled: false
          },
          {
            id: 'pricing',
            title:
              this.props.data.profile_ContractVersion === 2
                ? 'Trip Information'
                : 'Pricing',
            disabled: !this.props.pricingAllowed
          },
          {
            id: 'passenger',
            title: 'Passenger',
            content: 'Passenger',
            disabled: !this.props.passengerAllowed
          },
          {
            id: 'trip-summary',
            title: 'Trip Summary',
            content: 'Trip Summary',
            disabled: !this.props.summaryAllowed
          }
        ]
      });
    }
  }

  componentDidMount = () => {
    window.addEventListener('quoting_continue', props => {
      return this.onListBoxClick(props.detail.panel);
    });
    this.props.onReload();

    if (this.props.pageWidth < 992) {
      const element = document.getElementById('quoting-mobile-nav');
      setTimeout(() => {
        element.scrollLeft =
          document
            .querySelector('#quoting-mobile-nav .nav-item.active')
            .getBoundingClientRect().x - 20;
      }, 500);
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('goto', props => {
      return this.onListBoxClick(props.detail.panel);
    });
  };

  onListBoxClick = itemId => {
    this.setState({
      panelActive: itemId
    });

    if (this.props.pageWidth < 992) {
      setTimeout(() => {
        const element = document.getElementById('quoting-mobile-nav');
        element.scrollLeft = 0;
        element.scrollLeft = document
          .querySelector('#quoting-mobile-nav .nav-item.active')
          .getBoundingClientRect().x;
      }, 500);
    }
  };

  getActiveContent = () => {
    switch (this.state.panelActive) {
      case 'type':
        return (
          <Type
            {...this.props}
            {...this.state}
            nextClick={() => this.onListBoxClick('flight-info')}
            onLogout={this.props.onLogout}
            isMobile={this.props.pageWidth < 992}
            navClick={itemId => this.onListBoxClick(itemId)}
          />
        );
      case 'flight-info':
        return (
          <FlightInfo
            {...this.props}
            {...this.state}
            nextClick={() => this.onListBoxClick('pricing')}
            prevClick={() => this.onListBoxClick('type')}
            isMobile={this.props.pageWidth < 992}
            navClick={itemId => this.onListBoxClick(itemId)}
          />
        );
      case 'pricing':
        return (
          <Pricing
            {...this.props}
            {...this.state}
            nextClick={() => this.onListBoxClick('passenger')}
            prevClick={() => this.onListBoxClick('flight-info')}
            isMobile={this.props.pageWidth < 992}
            navClick={itemId => this.onListBoxClick(itemId)}
          />
        );
      case 'passenger':
        return (
          <Passenger
            {...this.props}
            {...this.state}
            nextClick={() => this.onListBoxClick('trip-summary')}
            prevClick={() => this.onListBoxClick('pricing')}
            isMobile={this.props.pageWidth < 992}
            navClick={itemId => this.onListBoxClick(itemId)}
          />
        );
      case 'trip-summary':
        return (
          <TripSummary
            {...this.props}
            {...this.state}
            nextClick={() => this.onListBoxClick('thank-you')}
            prevClick={() => this.onListBoxClick('passenger')}
            isMobile={this.props.pageWidth < 992}
            navClick={itemId => this.onListBoxClick(itemId)}
          />
        );
      case 'thank-you':
        return (
          <ThankYou
            prevClick={() => this.onListBoxClick('type')}
            isMobile={this.props.pageWidth < 992}
          />
        );
      default:
        return <div />;
    }
  };

  render() {
    const isMobile = this.props.pageWidth < 992;
    let className = '';
    const styles = {};

    if (isMobile) {
      className = 'pt-5 mb-5';
      styles.backgroundColor = 'white';
    } else {
      className = 'd-flex align-items-center h-100';
      styles.height = this.props.pageHeight + 'px';
      styles.backgroundImage = `url(${Clouds})`;
      styles.backgroundSize = '100% 100%';
      styles.paddingTop = '4rem';
      styles.paddingBottom = '5rem';
      styles.overflowY = 'scroll';
      styles.backgroundPosition = 'center center';
    }

    const activeContent = this.getActiveContent();

    return (
      <div id={this.props.id} style={styles}>
        <div
          style={isMobile ? {} : { minHeight: '100%' }}
          className={!isMobile ? 'd-flex align-items-center' : ''}
        >
          <Container
            className={className}
            style={{
              height: isMobile ? 'auto' : this.props.pageHeight + 'px'
            }}
          >
            <Row className={isMobile ? '' : 'w-100'}>
              <Col lg={3} className={'d-none d-lg-block'}>
                {this.state.panels.map(item => (
                  <ListBox
                    key={item.id}
                    activeBox={this.state.panelActive}
                    title={item.title}
                    size={12}
                    id={item.id}
                    click={() => this.onListBoxClick(item.id)}
                    disabled={item.disabled}
                    styles={item.disabled ? { cursor: 'not-allowed' } : {}}
                  />
                ))}
              </Col>
              <Col
                lg={{ offset: 1, size: 8 }}
                md={12}
                className={'pt-3' + (isMobile ? ' px-0' : '')}
              >
                {activeContent}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    mail: state.auth.mail,
    isAuthenticated: state.auth.token !== null,
    data: state.auth.data,
    quoting: state.flightInfo,
    pricingAllowed: state.flightInfo.pricingAllowed,
    passengerAllowed: state.flightInfo.passengerAllowed,
    summaryAllowed: state.flightInfo.summaryAllowed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => dispatch(actions.logout()),
    onReload: () => dispatch(actions.quotingReload())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Board);



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/Board.jsx